import {setup} from './web-core/src/setup';
import './sass/instance.scss';

import AppConfig from './config/Config.js';

const url  = window.origin + '/api/';

setup(AppConfig, url);
